import React from 'react';
import PropTypes from 'prop-types';
import './MobileHead.css';

const MobileHead = props => (
  <div className="mobile-head">
    <h1>{props.title}</h1>
  </div>
);

MobileHead.propTypes = {
  title: PropTypes.string,
};

export default MobileHead;



// WEBPACK FOOTER //
// ./src/components/MobileHead/MobileHead.jsx